var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"bi bi-paperclip",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }